<template>
  <section class="pt-20 bg-gray-800 text-white py-16 text-center">
    <h1 class="text-4xl font-bold">{{ title }}</h1>
    <p class="text-lg mt-2">{{ subtitle }}</p>
  </section>
</template>

<script setup lang="ts">
// accept title  subtitle from parent
const props = defineProps<{
  title: string;
  subtitle?: string;
}>();
</script>
